var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "#1A1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2135 36.9729C52.726 30.4279 47.0168 27.4812 42.0018 27.4812C42.0018 27.4812 42.0018 27.4812 41.9877 27.4812C36.9868 27.4812 31.2635 30.4137 29.776 36.9587C28.1185 44.2687 32.5952 50.4595 36.6468 54.3554C38.1485 55.8004 40.0752 56.5229 42.0018 56.5229C43.9285 56.5229 45.8552 55.8004 47.3427 54.3554C51.3943 50.4595 55.871 44.2829 54.2135 36.9729ZM42.0018 44.0704C39.5368 44.0704 37.5393 42.0729 37.5393 39.6079C37.5393 37.1429 39.5368 35.1454 42.0018 35.1454C44.4668 35.1454 46.4643 37.1429 46.4643 39.6079C46.4643 42.0729 44.4668 44.0704 42.0018 44.0704Z",
    fill: "#743FAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.50f386d7b42e044fea2bcd54e3e3fd42.svg";
export { ForwardRef as ReactComponent };